/**
 * Sincroniza logout entre abas/janelas do MESMO browser (mesmo perfil) via
 * BroadcastChannel.
 *
 * Por quê: o "Sair" (POST /auth/logout) é per-device de propósito e NÃO emite
 * `auth.session_revoked` (esse sinal é só do "Sair de todos os dispositivos").
 * Mas abas do mesmo browser COMPARTILHAM o cookie de refresh — deslogar numa
 * mata a sessão das outras; sem isso a outra aba só caía no F5. Aqui avisamos
 * na hora, client-side, sem depender do socket (cobre até socket caído).
 *
 * Escopo: só o mesmo browser/perfil (é o cenário — sessão compartilhada).
 * Outros devices/browsers têm cookie próprio e não são afetados (intenção do
 * logout per-device preservada).
 */
const CHANNEL = 'chatplus-auth';

let channel: BroadcastChannel | null = null;
function getChannel(): BroadcastChannel | null {
  if (typeof BroadcastChannel === 'undefined') return null;
  if (!channel) channel = new BroadcastChannel(CHANNEL);
  return channel;
}

/** Avisa as OUTRAS abas do mesmo browser que a sessão acabou. */
export function broadcastLogout(): void {
  getChannel()?.postMessage({ type: 'logout' });
}

/** Registra o listener de logout entre abas; retorna cleanup. Chamar 1x por aba. */
export function onLogoutBroadcast(cb: () => void): () => void {
  const ch = getChannel();
  if (!ch) return () => {};
  const handler = (e: MessageEvent): void => {
    if ((e.data as { type?: string } | null)?.type === 'logout') cb();
  };
  ch.addEventListener('message', handler);
  return () => ch.removeEventListener('message', handler);
}
